<template>
   <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h3>Personas</h3>
            </div>
        </div>
        <k-table :params="params" :filterStatus="filterStatus" @crear="crear" :createButton="createButton" 
        :editButton="false" :deleteButton="false" ref="listaPersonas" 
        @seleccionar="seleccionar" :path="url + '/personas/search'" :columns="[
            {
                display : 'Identificación',
                value : 'identificacion'
            },
            {
                display : 'Nombre',
                value : 'nombre'
            },
            {
                display : 'Contacto',
                value : 'contacto'
            }
        ]">
        </k-table>
        <modal :width="'80%'" height="auto" :scrollable="true"  name="crearPersona">
            <persona :tipoFiltro="tipoFiltro" permiteCrearPersona :permiteEliminarPersona="false" :permiteEditarPersona="false" :searchButton="false" @created="createdPersona"></persona>
        </modal>
    </div>
</template>

<script>
export default {
    props : {
        createButton : {
            type : Boolean,
            required : false,
            default : true
        },
        filterStatus : {
            type : Boolean,
            required : false,
            default : true
        },
        tipoFiltro : {
            type : String,
            required : false,
            default : ''
        }
    },
    data : function () {
        return {
            currentIndex : -1,
            currentPersona : null,
            url : url,
            params : {
                tipoFiltro : this.tipoFiltro
            }
        }
    },
    methods : {            
            seleccionar : function(currentPersona) {
                this.$emit('selected', currentPersona);
                this.$emit('cerrarModal');
            },
             crear : function () {
                this.$modal.show('crearPersona');
            },
            createdPersona: function (persona) {
                this.$refs.listaPersonas.actualizarLista(persona);
                this.$modal.hide('crearPersona');
            }
    }

}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/mantenimiento/personas/ListaPersonas.vue